export const environment = {
  webAPIRoot: 'https://webapiproxy-uat.traffictech.com/api' /*TEST*/,
};
